// Cột hiển thị 1 bước ký ở chế độ xem/phê duyệt — markup giữ nguyên như V1.
import React from "react";
import Moment from "react-moment";
import { checkRole } from "../../model";
import SignActionButtons from "./SignActionButtons";

export default function ProcessStepView({
  group,
  detail,
  user,
  userComment,
  setUserComment,
  buttonLoading,
  handleApprove,
  handleApproveQues,
  handleRequestUpdate,
  giveBack,
  handleReject,
  deleteStep,
  addMember,
}) {
  const currentUserId = user.data.id;
  const currentUserInGroup = group.member.some((m) => m.user_id == currentUserId);
  const currentUserStep = group.member.find((m) => m.user_id == currentUserId);
  const roleDelete =
    currentUserStep && currentUserId == currentUserStep.user_id && currentUserStep.step_type == 1;
  // Quyền role: ai có workflow_walking.deletestep đều được gỡ người CHƯA ký (action=0) ở mọi bước.
  const canDeleteByRole = checkRole(user, "workflow_walking", "deletestep");

  return (
    <div className="col-12 col-sm-4 mb-2 item-totrinh" key={group.position}>
      <div className="wrapper border rounded shaddow">
        <h4 className="text-center item-header pl-3 pr-3 pt-2 pb-2 border-bottom">
          {group.position}. {group.group_name}
        </h4>
        <div className="w-100 pl-3 pr-3 pt-2 pb-2 info">
          {group.member.map((m) => (
            <div className="item-user" key={m.id}>
              <div className="user-status">
                <div className="">
                  <strong>{m.fullname}</strong>
                </div>

                <div className="check_status">
                  {m.action == 1 && (
                    <p className="text-success">
                      <span className="fas fa-check-circle"></span>
                      <i className="ml-1"> Đã duyệt</i>
                    </p>
                  )}
                  {m.action == 2 && (
                    <p className="text-info">
                      <span className="fas fa-times-circle"></span>
                      <i className="ml-1"> Yêu cầu bổ sung</i>
                    </p>
                  )}
                  {m.action == 3 && (
                    <p className="text-danger">
                      <span className="fas fa-times-circle"></span>
                      <i className="ml-1"> Trả về</i>
                    </p>
                  )}
                  {m.action == 4 && (
                    <p className="text-danger">
                      <span className="fas fa-times-circle"></span>
                      <i className="ml-1"> Hủy bỏ</i>
                    </p>
                  )}
                  {m.action == 5 && (
                    <p className="text-secondary">
                      <span className="far fa-question-circle"></span>
                      <i className="ml-1"> Xin ý kiến</i>
                    </p>
                  )}
                  {m.action == 0 && detail && detail.status == 1 && (
                    <p className="text-warning">
                      <span className="fas fa-clock"></span>
                      <i className="ml-1"> Chờ ký</i>
                    </p>
                  )}
                  {m.timecheck && (
                    <small>
                      <span className="far fa-clock"></span>
                      <Moment format="HH:mm DD/MM/YYYY">{m.timecheck}</Moment>
                    </small>
                  )}
                </div>

                {(((roleDelete && m.user_id != currentUserId && m.action != 1) &&
                  detail.my_child.some((u) => u.id == m.user_id)) ||
                  (user.data.id == detail.author_id && detail.position == 1 && m.action != 1) ||
                  (canDeleteByRole && detail.status == 1 && m.action == 0)) && (
                  <div className="check_status delete-group">
                    <button type="button" className="text-danger button-delete" onClick={() => deleteStep(m.id)}>
                      <span className="fas fa-trash-alt "></span>
                      <i className="ml-1"> Xóa</i>
                    </button>
                  </div>
                )}
              </div>

              <div className="check-comment">
                {m.note_comment && (
                  <div className="w-100">
                    <i className="far fa-comment-dots"></i>
                    <small> {m.note_comment}</small>
                  </div>
                )}
              </div>

              {detail.id > 0 &&
                m.user_id == currentUserId &&
                m.action != 1 &&
                m.position == detail.position &&
                currentUserInGroup &&
                detail.status == 1 && (
                  <SignActionButtons
                    currentUserStep={currentUserStep}
                    group={group}
                    detail={detail}
                    userComment={userComment}
                    setUserComment={setUserComment}
                    buttonLoading={buttonLoading}
                    handleApprove={handleApprove}
                    handleApproveQues={handleApproveQues}
                    handleRequestUpdate={handleRequestUpdate}
                    giveBack={giveBack}
                    handleReject={handleReject}
                    addMember={addMember}
                  />
                )}
            </div>
          ))}
          {detail.position == 0 &&
            group.position >= detail.waiting_position &&
            (detail.author_id == user.data.id || user.data.id == 1) && (
              <div className="w-100 mt-2">
                <button
                  type="button"
                  className="w-100 btn btn-sm btn-primary"
                  onClick={() => addMember(group.position, group.group_name)}
                >
                  <span className="fas fa-user-plus"></span> Thêm người ký
                </button>
              </div>
            )}
        </div>
      </div>
    </div>
  );
}
